import { ChangeEvent, Dispatch } from 'react'
import { track } from '../lib/tracking'
import { AppAction, AppState } from '../state/fixedAppState'
import CustomSelect from './CustomSelect'
import PlacementAmountInput from './PlacementAmountInput'

interface Props {
  appState: AppState
  appDispatch: Dispatch<AppAction>
  variant: 'corporateFixed' | 'privateFixed'
}

export default function FixedCalculator({ appState, appDispatch, variant }: Readonly<Props>) {
  const { interestRateIndex, interestRateObjs, calculationState } = appState

  function mortgageRateIndexOnChangeHandler(event: ChangeEvent<HTMLSelectElement>) {
    appDispatch({ type: 'interestRateIndexChange', value: +event.target.value })
    track('change', 'interestRate')
  }

  return (
    <>
      <div className="mb-6 flex flex-col max-w-[376px]">
        <PlacementAmountInput appState={appState} appDispatch={appDispatch} variant={variant} />
        <CustomSelect
          label="Hur länge vill ni binda pengarna?"
          value={interestRateIndex}
          selectChangeHandler={mortgageRateIndexOnChangeHandler}
          options={interestRateObjs}
          wide
          disabled={calculationState !== 'ok'}
        />
      </div>
      <hr aria-hidden="true" className="mb-6 h-px bg-neutral-95 text-neutral-95 sm:mb-7" />
    </>
  )
}
